import { colors } from '../colors'

export const greenPalette = {
  text: {
    primary: colors.text,
  },
  primary: {
    contrastText: '#ffffff',
    light: '#d9f3e2',
    main: colors.green,
  },
  secondary: {
    contrastText: '#ffffff',
    dark: '#7c1310',
    main: '#e43631',
  },
}
